import { Component } from '@angular/core';

@Component({
    selector: 'app-pesquisa-salarial-bloqueio-assinatura',
    templateUrl: './bloqueio-assinatura.component.html',
    styleUrls: ['./bloqueio-assinatura.component.css']
})

export class PesquisaSalarialBloqueioAssinaturaComponent {
}
